import {
  GRAFTCODE_ONBOARDING_SCENARIOS,
  GRAFTCODE_ONBOARDING_SETUP_MODE,
  type GraftcodeOnboardingScenarioId,
  type GraftcodeOnboardingSetupMode,
} from '../graftcode-onboarding.const'
import type { GraftcodeOnboardingStackOption } from '../graftcode-onboarding-stacks.const'
import {
  GRAFTCODE_ONBOARDING_AGENT_STACKS_BY_SCENARIO,
  GRAFTCODE_ONBOARDING_STACKS_BY_SCENARIO,
} from '../graftcode-onboarding-stacks.const'

export function getOnboardingStacksForScenario(
  scenarioId: GraftcodeOnboardingScenarioId,
  setupMode: GraftcodeOnboardingSetupMode = GRAFTCODE_ONBOARDING_SETUP_MODE.manual
): GraftcodeOnboardingStackOption[] {
  if (setupMode === GRAFTCODE_ONBOARDING_SETUP_MODE.agent) {
    return GRAFTCODE_ONBOARDING_AGENT_STACKS_BY_SCENARIO[scenarioId] ?? []
  }
  return GRAFTCODE_ONBOARDING_STACKS_BY_SCENARIO[scenarioId] ?? []
}

export function resolveDefaultStackForScenario(
  scenarioId: GraftcodeOnboardingScenarioId,
  setupMode: GraftcodeOnboardingSetupMode = GRAFTCODE_ONBOARDING_SETUP_MODE.manual
): string {
  const scenario = GRAFTCODE_ONBOARDING_SCENARIOS.find((item) => item.id === scenarioId)
  const stacks = getOnboardingStacksForScenario(scenarioId, setupMode)
  if (!stacks.length) {
    return scenario?.defaultStack ?? 'javascript'
  }
  if (scenario && stacks.some((stack) => stack.id === scenario.defaultStack)) {
    return scenario.defaultStack
  }
  return stacks[0]?.id ?? scenario?.defaultStack ?? 'javascript'
}
